var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{attrs:{"show":_vm.countdown,"variant":_vm.variant,"dismissible":_vm.closable,"fade":""},on:{"dismissed":_vm.close,"dismiss-count-down":_vm.handleCountdown}},[_vm._v(" "+_vm._s(_vm.message)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }